import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { TableRow } from '../component/TableRow'
import Pagination from '../../../../components/Pagination'
import { Context } from '../MBDoisoat'

const _Table = () => {

  const { state, dispatch } = useContext(Context);

  const doisoat = useCallback((id) => {
    dispatch({
      type: 'DOI_SOAT',
      payload: {
        id: id,
      }
    })
  }, [dispatch])
  
  const upload = useCallback((id) => {
    dispatch({
      type: 'UPLOAD',
      payload: {
        id: id,
      }
    })
  }, [dispatch])
  
  const download = useCallback((id) => {
    dispatch({
      type: 'DOWNLOAD',
      payload: {
        id: id,
      }
    })
  }, [dispatch])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Ngày đối soát</th>
              <th scope="col">Chi tiết</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {state.data.list && state.data.list.map((pv, index) => <TableRow onUpload={upload} onDownload={download} onDoisoat={doisoat} rIndex={index} key={`table-keys-lottmekong-${pv.id}`} data={pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: 'UPDATE_PAGE',
                    payload: i
                  })
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
};

export default React.memo(_Table)